import { render, staticRenderFns } from "./RealtimeComponent.vue?vue&type=template&id=1a5b4121&scoped=true&"
import script from "./RealtimeComponent.vue?vue&type=script&lang=js&"
export * from "./RealtimeComponent.vue?vue&type=script&lang=js&"
import style0 from "./RealtimeComponent.vue?vue&type=style&index=0&id=1a5b4121&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5b4121",
  null
  
)

export default component.exports